<div class="page-actions">
  <dv-button
    color="primary"
    icon="add"
    (click)="onCreateClick()"
    routerLink="new/information">
    {{ 'RouteNetwork.New' | translate | uppercase }}
  </dv-button>
</div>

<dv-vertical-splitter
  id="route-network-vertical-splitter"
  [resizableSide]="resizableSide.Right">
  <div left-side>
    <app-route-networks-grid />
  </div>
  <div right-side>
    <router-outlet />
  </div>
</dv-vertical-splitter>
